import { useMemo } from 'react';
import {
  AttachmentFile,
  FieldResultProps,
} from 'pages/Forms/FormResults/types/types';
import {
  imageFormats,
  fileFormats,
} from 'pages/Forms/RegisterForm/CustomFormBuilder/components/UploadAttachments/CommonAttachment/constants';
import { useAttachmentResult } from 'pages/Forms/FormResults/FormResultDetails/ResultInputs/utils/useAttachmentResult';
import { ImageComponent } from 'pages/Forms/FormResults/FormResultDetails/ResultInputs/components/common/ImageComponent';
import { FileDownloadComponent } from 'pages/Forms/FormResults/FormResultDetails/ResultInputs/components/common/FileDownloadComponent';

export const useInstructionUtils = (item: FieldResultProps['item']) => {
  const memoizedAnswer = useMemo(
    () =>
      item?.attachments?.map((attachment) => ({
        id: attachment.id,
        name: attachment.name || '',
        file: attachment.file || '',
        mime_type: attachment.mime_type,
        attachmentId: attachment.id,
      })),
    [item?.attachments],
  );

  const { attachFile, handleDownload } = useAttachmentResult({
    ...item,
    answer: memoizedAnswer,
  });

  const renderAttachment = (attachment: AttachmentFile) => {
    if (imageFormats.includes(attachment.mime_type)) {
      return <ImageComponent photo={attachment} />;
    }
    if (fileFormats.includes(attachment.mime_type)) {
      return (
        <FileDownloadComponent
          imageData={attachment}
          handleDownload={handleDownload}
        />
      );
    }
    return null;
  };

  return { attachFile, renderAttachment };
};
